import React from "react";
import { getYear, getMonth } from "date-fns";
import range from "lodash/range";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];


const RenderCustomHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  startYear = 1990,
  endYear = 1,
}) => {
  const years = range(1990, getYear(new Date()) + endYear);

  return (
    <div
      style={{
        margin: 10,
        display: "flex",
        justifyContent: "center",
        gap: "8px",
        alignItems: "center",
      }}
    >
      <button
        type="button"
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
      >
        {"<"}
      </button>

      <select
        value={getYear(date)}
        onChange={(e) => changeYear(Number(e.target.value))}
      >
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>

      <select
        value={getMonth(date)}
        onChange={(e) => changeMonth(Number(e.target.value))}
      >
        {MONTHS.map((month, index) => (
          <option key={month} value={index}>
            {month}
          </option>
        ))}
      </select>

      <button
        type="button"
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
      >
        {">"}
      </button>
    </div>
  );
};

export default RenderCustomHeader;